import React from 'react';
import { ListGroupItem, Row, Col, InputGroup, Input } from 'reactstrap';

const DependsOnQuestionsListItem = props => {

    const { topMainListItem, mainListItem, checkboxLabel } = styles;
    const choseRightStyle = (props.iterator === 0) ? topMainListItem : mainListItem;

    return (
        <ListGroupItem style={choseRightStyle}>
            <Row>
                <Col xs={2} sm={1}>
                    <InputGroup style={checkboxLabel}>
                        <Input type="checkbox" name={props.dependsOnQuestion.name}
                            id={props.dependsOnQuestion.id}
                            checked={Number(props.dependsOnQuestion.id) === Number(props.questionState.dependsOnQuestionId)}
                            onChange={props.changeQuestionState} />
                    </InputGroup>
                </Col>
                <Col id={"dependsOnQuestion" + props.iterator} >{props.dependsOnQuestion.name}</Col>
            </Row>
        </ListGroupItem>
    );
}

export default DependsOnQuestionsListItem;

const styles = {
    topMainListItem: {
        border: 'none',
        borderBottom: '1px solid #dee2e7',
        background: 'none',
        paddingBottom: 8,
        paddingTop: 0
    },
    mainListItem: {
        border: 'none',
        borderBottom: '1px solid #dee2e7',
        background: 'none',
        paddingBottom: 8,
    },
    checkboxLabel: {
        paddingLeft: '0.2rem',
        width: '100%'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/common/dependsOn/DependsOnQuestionsListItem.js